export default __webpack_public_path__ + "static/media/utr-sports-logo.c4e01beb.svg";